import { render, staticRenderFns } from "./LocationListTable.vue?vue&type=template&id=80da8182&"
import script from "./LocationListTable.vue?vue&type=script&lang=js&"
export * from "./LocationListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports